"use strict";

jQuery(function ($) {
  function setCriteriaField() {
    var country = $('.filter_country').select2('data');
    var product = $('.filter_product').select2('data');
    if (country && product) $('.modal_market input.search-criteria').val(country[0].text + ' - ' + product[0].text);
  }

  $('.modal-toggle').on('click', function (e) {
    e.preventDefault();
    setCriteriaField();
    $('.modal_market').toggleClass('is-visible');
    $('.modal_market .show-more').show();
    $('.modal_market .request-data').hide();
    $('.modal_market textarea').html('N/A');
  });
  $('.modal-toggle-request').on('click', function (e) {
    e.preventDefault();
    setCriteriaField();
    $('.modal_market').toggleClass('is-visible');
    $('.modal_market .show-more').hide();
    $('.modal_market .request-data').show();
    $('.modal_market textarea').html('Requesting data');
  });
  $('select.filter_select').select2({
    width: '100%',
    minimumResultsForSearch: -1
  });
});